<div
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-100"
>
    <div
        class="bg-white rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto shadow-xl"
    >
        <!-- Header -->
        <div
            class="flex justify-between items-center py-[8px] px-[16px] border-b border-gray-300"
        >
            <h2 class="text-xl font-semibold mb-2">
                {{ "guard-shift-details.common.profile-overview" | translate }}
            </h2>
            <button
                (click)="closeModal()"
                class="text-gray-500 hover:text-gray-700 p-[4px] rounded-full hover:bg-gray-100 transition-colors"
                aria-label="Close"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-x"
                    viewBox="0 0 24 24"
                >
                    <path d="M18 6 6 18"></path>
                    <path d="m6 6 12 12"></path>
                </svg>
            </button>
        </div>

        <!-- Profile Header -->
        <div class="bg-gray-50 p-[24px] pt-4">
            <div class="flex items-start gap-[24px]">
                <div class="relative">
                    <img
                        [src]="guardDetails.image"
                        [alt]="
                            'guard-shift-details.common.profile-overview'
                                | translate
                        "
                        class="w-[85px] h-[85px] rounded-full object-cover border-[4px] border-white shadow-md"
                        loading="lazy"
                    />
                </div>
                <div class="flex-1">
                    <div class="flex items-center gap-[20px]">
                        <h3 class="text-2xl font-semibold" style="margin: 0px">
                            {{
                                guardDetails.aliasName
                                    ? guardDetails.aliasName
                                    : guardDetails.firstName
                                      ? guardDetails.firstName
                                      : "-"
                            }}
                        </h3>
                        @if (guardDetails.checkInOnTime) {
                            <span
                                class="text-blue-600 bg-blue-50 px-[10px] py-[2px] rounded-md text-sm font-medium border border-blue-100"
                            >
                                {{ guardDetails.checkInOnTime }}%
                                {{
                                    "guard-shift-details.common.check-in-on-time"
                                        | translate
                                }}
                            </span>
                        } @else {}
                    </div>
                    <div class="flex items-center mt-[8px]">
                        <div
                            class="flex items-center bg-blue-50 text-blue-700 px-[12px] py-[6px] rounded-lg border border-blue-100"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="lucide lucide-briefcase mr-[8px]"
                            >
                                <path
                                    d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"
                                ></path>
                                <rect
                                    width="20"
                                    height="14"
                                    x="2"
                                    y="6"
                                    rx="2"
                                ></rect>
                            </svg>
                            @if (guardDetails.totalShiftsForCustomer == 1) {
                                <span class="font-medium"
                                    >{{
                                        "guard-shift-details.common.worked-with-your-company"
                                            | translate
                                    }}:
                                    {{ guardDetails.totalShiftsForCustomer }}
                                    {{
                                        "guard-shift-details.common.time"
                                            | translate
                                    }}</span
                                >
                            } @else {
                                <span class="font-medium"
                                    >{{
                                        "guard-shift-details.common.worked-with-your-company"
                                            | translate
                                    }}:
                                    {{ guardDetails.totalShiftsForCustomer }}
                                    {{
                                        "guard-shift-details.common.times"
                                            | translate
                                    }}</span
                                >
                            }
                        </div>
                    </div>
                    <div class="flex gap-[12px] mt-[16px]">
                        <button
                            style="border-radius: 50px"
                            class="flex items-center justify-center gap-[8px] bg-gray-200 text-gray-700 rounded-full pl-[16px] pr-[20px] py-[12px] shadow-sm hover:bg-gray-400 transition-colors"
                            aria-label="Phone"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="lucide lucide-phone"
                            >
                                <path
                                    d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                                ></path>
                            </svg>
                            <span class="font-medium">{{
                                formatSwedishPhone(guardDetails.phone)
                            }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Summary -->
        @if (isValidBiography(guardDetails.biography)) {
            <div class="p-6 border-b border-gray-300">
                <h3 class="text-lg font-semibold mb-3">
                    {{
                        "guard-shift-details.common.profile-summary" | translate
                    }}
                </h3>
                <p class="text-gray-700 leading-relaxed">
                    {{ guardDetails.biography }}
                </p>
            </div>
        }

        @if (mergedWorkExperiences?.length > 0) {
            <div class="p-[24px] border-b border-gray-300">
                <h3 class="text-lg font-semibold mb-[16px]">
                    {{
                        "guard-shift-details.common.previous-experience"
                            | translate
                    }}
                </h3>
                <div class="grid grid-cols-3 gap-[16px]">
                    @for (
                        experience of mergedWorkExperiences;
                        track experience
                    ) {
                        <div
                            class="flex flex-col items-center text-center p-[16px] bg-gray-50 rounded-lg border border-gray-100 shadow-sm hover:shadow-md transition-shadow"
                        >
                            <!-- Logo or Initial -->
                            <div
                                class="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 text-lg font-semibold mb-2 overflow-hidden"
                            >
                                @if (experience.companyLogoUrl) {
                                    <img
                                        src="{{ experience.companyLogoUrl }}"
                                        alt="{{ experience.companyName || '' }}"
                                        class="w-full h-full object-contain"
                                        loading="lazy"
                                    />
                                } @else {
                                    {{
                                        experience.companyName?.charAt(0) || "?"
                                    }}
                                }
                            </div>

                            <!-- Company Name -->
                            <div class="font-medium text-gray-900 text-sm mb-1">
                                {{ experience.companyName || "" | titlecase }}
                            </div>
                            <!-- Skills -->
                            <div class="flex flex-col items-center">
                                @for (
                                    skill of isExpanded(experience)
                                        ? experience.skills || []
                                        : (experience.skills || []).slice(0, 3);
                                    track skill
                                ) {
                                    <div
                                        class="text-gray-600 text-sm break-all whitespace-normal"
                                    >
                                        {{ skill }}
                                    </div>
                                }

                                @if ((experience.skills || []).length > 3) {
                                    <button
                                        type="button"
                                        class="mt-2 text-blue-600 text-sm hover:underline focus:outline-none"
                                        (click)="toggleSkills(experience)"
                                    >
                                        {{
                                            isExpanded(experience)
                                                ? ("guard-details.show-less"
                                                  | translate)
                                                : ("guard-details.show-more"
                                                  | translate)
                                        }}
                                    </button>
                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
        }

        <!-- Skills -->
        <div class="p-[24px] border-b border-gray-300">
            <h3 class="text-lg font-semibold mb-[16px]">
                {{ "guard-shift-details.common.skill" | translate }}:
            </h3>

            <div class="flex flex-wrap gap-[12px]">
                @if (guardDetails.skills?.length > 0) {
                    @for (
                        skill of guardDetails.skills;
                        let i = $index;
                        track skill
                    ) {
                        @switch (i % 3) {
                            @case (0) {
                                <div
                                    class="px-[16px] py-[8px] rounded-full text-sm font-medium flex items-center gap-[4px] shadow-sm bg-blue-100 text-blue-700 border border-blue-200"
                                >
                                    {{ skill | skillDisplayName }}
                                </div>
                            }
                            @case (1) {
                                <div
                                    class="px-[16px] py-[8px] rounded-full text-sm font-medium flex items-center gap-[4px] shadow-sm bg-green-100 text-green-700 border border-green-200"
                                >
                                    {{ skill | skillDisplayName }}
                                </div>
                            }
                            @case (2) {
                                <div
                                    class="px-[16px] py-[8px] rounded-full text-sm font-medium flex items-center gap-[4px] shadow-sm bg-red-100 text-red-700 border border-red-200"
                                >
                                    {{ skill | skillDisplayName }}
                                </div>
                            }
                        }
                    }
                }
            </div>
        </div>
        <!-- Reviews and Ratings -->
        <div class="p-6 border-b">
            <h3 class="text-lg font-semibold mb-4">
                {{ "guard-details.reviews-and-ratings" | translate }}
            </h3>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <!-- Co-worker Reviews -->
                <div
                    class="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-[20px] border border-blue-100 shadow-sm"
                >
                    <h4
                        class="text-base font-semibold text-gray-800 mb-[16px] flex items-center gap-[8px]"
                    >
                        <span
                            class="inline-flex p-[6px] bg-blue-100 rounded-lg"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="text-blue-600"
                            >
                                <path
                                    d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
                                ></path>
                                <circle cx="9" cy="7" r="4"></circle>
                                <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                            </svg>
                        </span>
                        {{
                            "guard-details.feedback-form-colleagues" | translate
                        }}
                    </h4>

                    <!-- Summary Stats -->
                    <div
                        class="bg-white rounded-xl p-[16px] mb-[16px] shadow-sm border border-blue-100"
                    >
                        <div class="text-center mb-[12px]">
                            <p class="text-xs text-gray-600 mb-[4px]">
                                {{ "guard-details.total-reviews" | translate }}
                            </p>
                            <p class="text-3xl font-bold text-blue-600">
                                {{
                                    getCombinedFeedback(
                                        guardDetails.feedbackFromColleagues,
                                        "total"
                                    )
                                }}
                            </p>
                        </div>

                        <div class="space-y-[12px]">
                            <!-- Excellent -->
                            <div
                                class="group hover:scale-[1.02] transition-transform"
                            >
                                <div
                                    class="flex items-center justify-between mb-[4px]"
                                >
                                    <span
                                        class="text-sm font-medium text-green-700"
                                    >
                                        {{
                                            "guard-details.excellent"
                                                | translate
                                        }}
                                    </span>
                                    <span
                                        class="text-sm font-bold text-green-700 bg-green-50 px-[8px] py-[2px] rounded-full"
                                    >
                                        {{
                                            getCombinedFeedback(
                                                guardDetails.feedbackFromColleagues,
                                                "excellent"
                                            )
                                        }}
                                    </span>
                                </div>
                                <div
                                    class="w-full bg-gray-200 rounded-full h-[10px] overflow-hidden"
                                >
                                    <div
                                        class="bg-gradient-to-r from-green-500 to-green-400 h-[10px] rounded-full transition-all duration-500 shadow-sm"
                                        [style.width]="
                                            getFeedbackPercentage(
                                                guardDetails.feedbackFromColleagues,
                                                'excellent'
                                            )
                                        "
                                    ></div>
                                </div>
                            </div>

                            <!-- Average -->
                            <div
                                class="group hover:scale-[1.02] transition-transform"
                            >
                                <div
                                    class="flex items-center justify-between mb-[4px]"
                                >
                                    <span
                                        class="text-sm font-medium text-blue-700"
                                    >
                                        {{ "guard-details.good" | translate }}
                                    </span>
                                    <span
                                        class="text-sm font-bold text-blue-700 bg-blue-50 px-[8px] py-[2px] rounded-full"
                                    >
                                        {{
                                            getCombinedFeedback(
                                                guardDetails.feedbackFromColleagues,
                                                "good"
                                            )
                                        }}
                                    </span>
                                </div>
                                <div
                                    class="w-full bg-gray-200 rounded-full h-[10px] overflow-hidden"
                                >
                                    <div
                                        class="bg-gradient-to-r from-blue-500 to-blue-400 h-[10px] rounded-full transition-all duration-500 shadow-sm"
                                        [style.width]="
                                            getFeedbackPercentage(
                                                guardDetails.feedbackFromColleagues,
                                                'good'
                                            )
                                        "
                                    ></div>
                                </div>
                            </div>

                            <!-- Poor -->
                            <div
                                class="group hover:scale-[1.02] transition-transform"
                            >
                                <div
                                    class="flex items-center justify-between mb-[4px]"
                                >
                                    <span
                                        class="text-sm font-medium text-red-700"
                                    >
                                        {{ "guard-details.poor" | translate }}
                                    </span>
                                    <span
                                        class="text-sm font-bold text-red-700 bg-red-50 px-[8px] py-[2px] rounded-full"
                                    >
                                        {{
                                            getCombinedFeedback(
                                                guardDetails.feedbackFromColleagues,
                                                "poor"
                                            )
                                        }}
                                    </span>
                                </div>
                                <div
                                    class="w-full bg-gray-200 rounded-full h-[10px] overflow-hidden"
                                >
                                    <div
                                        class="bg-gradient-to-r from-red-500 to-red-400 h-[10px] rounded-full transition-all duration-500 shadow-sm"
                                        [style.width]="
                                            getFeedbackPercentage(
                                                guardDetails.feedbackFromColleagues,
                                                'poor'
                                            )
                                        "
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Company Ratings -->
                <div
                    class="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-[20px] border border-amber-100 shadow-sm"
                >
                    <!-- Header -->
                    <h4
                        class="text-[16px] font-semibold text-gray-800 mb-[16px] flex items-center gap-[8px]"
                    >
                        <span
                            class="inline-flex p-[6px] bg-amber-100 rounded-lg"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-[16px] h-[16px] text-amber-600 fill-amber-600"
                                viewBox="0 0 24 24"
                                stroke="none"
                            >
                                <path
                                    d="M12 17.27L18.18 21l-1.63-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.45 4.73L5.82 21z"
                                />
                            </svg>
                        </span>
                        {{ "guard-details.company-rating" | translate }}
                    </h4>
                    <!-- Average Rating -->
                    <!-- ⭐ Average Rating Section -->
                    <div
                        class="bg-white rounded-xl p-[16px] mb-[16px] shadow-sm border border-amber-100"
                        *ngIf="guardDetails?.rates?.length > 0"
                    >
                        <div class="flex items-center justify-between">
                            <div>
                                <p class="text-[12px] text-gray-600 mb-[4px]">
                                    {{
                                        "guard-details.average-rating"
                                            | translate
                                    }}
                                </p>

                                <div class="flex items-center gap-[8px]">
                                    <span
                                        class="text-[30px] font-bold text-amber-600"
                                    >
                                        {{
                                            getAverageRating(guardDetails.rates)
                                                | number: "1.1-1" : "en-US"
                                        }}
                                    </span>

                                    <!-- Dynamic Stars -->
                                    <div class="flex gap-[2px]">
                                        <ng-container
                                            *ngFor="
                                                let star of [1, 2, 3, 4, 5];
                                                let i = index
                                            "
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                class="w-[16px] h-[16px]"
                                                [ngClass]="{
                                                    'fill-amber-500 text-amber-500':
                                                        star <=
                                                        getAverageRating(
                                                            guardDetails.rates
                                                        ),
                                                    'fill-gray-200 text-gray-300':
                                                        star >
                                                        getAverageRating(
                                                            guardDetails.rates
                                                        ),
                                                }"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    d="M12 17.27L18.18 21l-1.63-7.03L22 9.24l-7.19-.61L12 2 
                   9.19 8.63 2 9.24l5.45 4.73L5.82 21z"
                                                />
                                            </svg>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>

                            <div class="text-right">
                                <p class="text-[12px] text-gray-500">
                                    {{ "guard-details.based-on" | translate }}
                                </p>
                                <p class="text-[24px] font-bold text-gray-700">
                                    {{ guardDetails.rates.length }}
                                </p>
                                <p class="text-[12px] text-gray-500">
                                    {{ "guard-details.company" | translate }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- 📊 Ratings List -->
                    <div
                        class="space-y-[8px] max-h-[192px] overflow-y-auto pr-[8px] scrollbar-thin scrollbar-thumb-amber-200 scrollbar-track-transparent"
                        *ngIf="guardDetails?.rates?.length > 0; else noRatings"
                    >
                        <div
                            class="bg-white rounded-lg p-[12px] border border-amber-100 hover:shadow-md hover:border-amber-200 transition-all duration-200 cursor-default"
                            *ngFor="
                                let rate of guardDetails.rates;
                                trackBy: trackByRate
                            "
                        >
                            <div class="flex items-start gap-[12px]">
                                <!-- Company Logo -->
                                <div class="flex-shrink-0">
                                    <div
                                        class="w-[40px] h-[40px] rounded-lg bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center overflow-hidden border border-gray-200"
                                    >
                                        <img
                                            *ngIf="rate.companyImage"
                                            [src]="rate.companyImage"
                                            (error)="onImageError($event)"
                                            [alt]="rate.companyName + ' logo'"
                                            class="w-full h-full object-contain p-[4px]"
                                        />
                                        <span
                                            *ngIf="!rate.companyImage"
                                            class="text-sm font-semibold text-gray-700"
                                        >
                                            {{
                                                rate.companyName?.charAt(0) ||
                                                    "?"
                                            }}
                                        </span>
                                    </div>
                                </div>

                                <!-- Company Info -->
                                <div class="flex-1 min-w-0">
                                    <div
                                        class="flex items-start justify-between mb-[8px]"
                                    >
                                        <span
                                            class="text-[14px] font-semibold text-gray-800 truncate"
                                        >
                                            {{ rate.companyName | titlecase }}
                                        </span>
                                        <div
                                            class="flex items-center gap-[4px] bg-amber-50 px-[8px] py-[4px] rounded-full flex-shrink-0 ml-[8px]"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                class="w-[14px] h-[14px] text-amber-500 fill-amber-500"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    d="M12 17.27L18.18 21l-1.63-7.03L22 9.24l-7.19-.61L12 2 
                   9.19 8.63 2 9.24l5.45 4.73L5.82 21z"
                                                />
                                            </svg>
                                            <span
                                                class="text-[14px] font-bold text-amber-700"
                                            >
                                                {{ rate.rate }}
                                            </span>
                                        </div>
                                    </div>

                                    <!-- <p class="text-[12px] text-gray-600 leading-relaxed" *ngIf="rate.comment">
          {{ rate.comment }}
        </p> -->
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- No Ratings -->
                    <ng-template #noRatings>
                        <div
                            class="text-center text-gray-500 text-sm py-[12px]"
                        >
                            {{ "guard-details.no-rating-yet" | translate }}
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>
